import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  productFilter: {},
  orderFilter: {},
  brandFilter: {},
  customerFilter: {},
  dealFilter: {}
}

const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setProductFilterData: (state, action) => {
      state.productFilter = action.payload
    },

    setOrderFilterData: (state, action) => {
      state.orderFilter = action.payload
    },

    setBrandFilterData: (state, action) => {
      state.brandFilter = action.payload
    },

    setCustomerFilterData: (state, action) => {
      state.customerFilter = action.payload
    },

    setDealFilterData: (state, action) => {
      state.dealFilter = action.payload
    }
  }
})

export const {
  setProductFilterData,
  setOrderFilterData,
  setBrandFilterData,
  setCustomerFilterData,
  setDealFilterData
} = filterSlice.actions

export default filterSlice.reducer
